import { Component, OnInit, Input } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-refer-success',
  templateUrl: './refer-success.component.html',
  styleUrls: ['./refer-success.component.css']
})
export class ReferSuccessComponent implements OnInit {

  constructor(private router: Router, private serviceURLService: serviceURLService, private location: Location) { }

  
  ngOnInit() {
    
  }
  goBack() {
    this.location.back();
    localStorage.setItem("backToPrevious","true");
  }   

}
